module.exports = ".topbar .top-navbar .navbar-header {\r\n    width: 80%;\r\n}"